export const ID_PREFIX = {
  JOB: "job_",
  SERVICE: "service_",
  USER: "user_",
} as const;
